import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getFileRequest,
  getRequest,
  postFormDataRequest,
  postRequest,
} from "../apiHelpers";
import {
  manualPaymentCandidatesURL,
  manualPaymentCaseByIdURL,
  manualPaymentCasesURL,
  manualPaymentDecisionURL,
  manualPaymentFinalizeURL,
  manualPaymentPermissionsURL,
  manualPaymentPreflightURL,
  manualPaymentSlipURL,
  manualPaymentSubmitURL,
  manualPaymentSyncURL,
} from "../pathApi";

const buildURL = (url, id) => url.replace(":id", String(id));

export const callGetManualPaymentPermissions = createAsyncThunk(
  "manualPayment/getPermissions",
  async () => {
    try {
      const response = await getRequest({
        url: manualPaymentPermissionsURL,
        showLoading: false,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callSearchPendingPayment = createAsyncThunk(
  "manualPayment/searchPending",
  async ({ q = "", ...params } = {}) => {
    try {
      const response = await getRequest({
        url: manualPaymentCandidatesURL,
        params: {
          q,
          ...params,
        },
        showLoading: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callGetManualPaymentCases = createAsyncThunk(
  "manualPayment/getCases",
  async (params = {}) => {
    try {
      const response = await getRequest({
        url: manualPaymentCasesURL,
        params,
        showLoading: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callCreateManualPaymentCase = createAsyncThunk(
  "manualPayment/createCase",
  async (body) => {
    try {
      const response = await postRequest({
        url: manualPaymentCasesURL,
        data: body,
        showLoading: true,
        showAlert: false,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callGetManualPaymentCase = createAsyncThunk(
  "manualPayment/getCase",
  async (id) => {
    try {
      const response = await getRequest({
        url: buildURL(manualPaymentCaseByIdURL, id),
        showLoading: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callSubmitManualPaymentProof = createAsyncThunk(
  "manualPayment/submitProof",
  async ({ id, formData }) => {
    try {
      const response = await postFormDataRequest({
        url: buildURL(manualPaymentSubmitURL, id),
        formData,
        showLoading: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callDecisionManualPaymentCase = createAsyncThunk(
  "manualPayment/decisionCase",
  async ({ id, body }) => {
    try {
      const response = await postRequest({
        url: buildURL(manualPaymentDecisionURL, id),
        data: body,
        showLoading: true,
        showAlert: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callSyncManualPaymentCase = createAsyncThunk(
  "manualPayment/syncCase",
  async (id) => {
    try {
      const response = await postRequest({
        url: buildURL(manualPaymentSyncURL, id),
        data: {},
        showLoading: true,
        showAlert: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callPreflightManualPaymentCase = createAsyncThunk(
  "manualPayment/preflightCase",
  async (id) => {
    try {
      const response = await getRequest({
        url: buildURL(manualPaymentPreflightURL, id),
        showLoading: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callFinalizeManualPaymentCase = createAsyncThunk(
  "manualPayment/finalizeCase",
  async ({ id, body }) => {
    try {
      const response = await postRequest({
        url: buildURL(manualPaymentFinalizeURL, id),
        data: body,
        showLoading: true,
        showAlert: true,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const callGetManualPaymentProof = async (id) => {
  try {
    const response = await getFileRequest({
      url: buildURL(manualPaymentSlipURL, id),
      showLoading: true,
    });

    return response;
  } catch (error) {
    throw error;
  }
};
